/**
 * Photo cropper
 *
 * This class wraps around the cropper plugin to make create a photo cropping dialog
 *
 * @author pponzeka@yext.com
 */
goog.module('yext.image.Photocrop');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const browser = goog.require('yext.browser');
const events = goog.require('yext.dam.assetselector.events');
const fileupload = goog.require('yext.fileupload');
const image = goog.require('yext.image');
const routes = goog.require('yext.storm.routes');


/** @const */ var DEFAULT_VIEW_MODE = 0;

/**
 * @constructor
 *
 * @param {!Object} options Override default options if needed
 */
const Photocrop = function(options) {
  this.options = $.extend(true, {}, Photocrop.DEFAULTS, options);
  this.$container = this.options.$container;
  this.$buttons = this.options.$buttons;
  this.initCropper();
};

Photocrop.DEFAULTS = {
  'constraints': {
    'width': 5,
    'height': 5,
    'cropOnlyOnInteraction': true,
  },
  'container': {
    'dimensions': {
      'MAX_SQUARE': 400,
      'MAX_WIDTH': 730,
      'MAX_HEIGHT': 730,
      'MAX_DEFAULT_SQUARE': 400,
      'MAX_DEFAULT_WIDTH': 730,
      'MAX_DEFAULT_HEIGHT': 730,
    },
  },
  'fillColor': '#ffffff',
};

/**
 * Initialize the cropper with default browser options
 */
Photocrop.prototype.initCropper = function() {
  this.$imgContainer = this.$container.find('.js-crop-preview');
  this.$imgContainer.cropper('destroy');
  var self = this;
  var cropperOptions = {
    'strict': true,
    'rotatable': false,
    'autoCropArea': 1,
    'background': false,
    'movable': false, // disables the ability to move the image
    'minContainerHeight': 5,
    'minContainerWidth': 5,
    'viewMode': 'viewMode' in this.options ? this.options['viewMode'] : DEFAULT_VIEW_MODE,
    'built': function() {
      if (self.options.constraints) {
        self.initCropperBox();
      }

      // make sure the image loads before showing buttons for interaction
      self.$container.find('.cropper-view-box img').on('load', function() {
        self.$buttons.show();
        self.unbindActions();
        self.bindActions();
        $(window).trigger('resize'); // make sure cropper is centered in the window
        // for really small screens, allow scrolling if the window is too small
        if ($(window).height() < self.$container.closest('.ui-dialog').height()) {
          $('body').removeClass('no-scroll');
        }
      }).each(function() {
        // make sure image load event is always triggered
        if (this.complete) {
          $(this).trigger('load');
        }
      });
    },
  };

  if (!browser.hasCanvasSupport() || (this.options.viewMode == 0)) {
    // disable scaling on browsers that don't use the canvas for cropping
    // & on viewMode 1 (used for BusinessLogo)
    cropperOptions['scalable'] = false;
    cropperOptions['zoomOnWheel'] = false;
    cropperOptions['zoomable'] = false;
  }

  this.cropperObject = this.$imgContainer.cropper(cropperOptions);
};

/**
 * Initialize the cropper with default browser options
 */
Photocrop.prototype.initView = function(asset, constraints) {
  this.options.asset = asset;
  if (constraints) {
    this.options.constraints = constraints;
  }

  var url = asset.photoUrl;

  this.$cropArea = this.$container.find('.js-crop-area');

  if (this.options.asset.file) {
    url = this.options.asset.photoUrl;

    if (!url) {
      url = this.options.asset.url;
    }
  } else {
    url = this.getExternalUrl();
  }

  this.calculateMaxContainerHeight();
  this.initImageCropping(url);
  this.initCropper();
  this.initCropboxDimensions();
  this.initAspectRatio();
  this.initCropListener();
};

/**
 * Calculates the maxContainerHeight & maxContainerWidth for the dialog body
 */
Photocrop.prototype.calculateMaxContainerHeight = function() {
  var $dialog = this.$container.parents('.ui-dialog');

  // if photocrop isn't container in a dialog we don't have to do anything
  if ($dialog.length == 0) {
    return;
  }

  var dimensions = this.options.container.dimensions;
  var headerHeight = $dialog.find('.ui-dialog-titlebar').outerHeight(true);
  var footerHeight = $dialog.find('.js-crop-buttons').outerHeight(true);
  var $photocrop = $dialog.find('.js-photo-crop');
  var bodyPaddingHeight = $photocrop.outerHeight(true) - $photocrop.outerHeight(false);
  var maxWindowHeight = $(window).height() -
        (headerHeight + footerHeight + bodyPaddingHeight + this.getTabSelectorHeight() + 30);
  // adding padding for the close button on the top

  if (dimensions.MAX_DEFAULT_HEIGHT > maxWindowHeight) {
    dimensions.MAX_HEIGHT = maxWindowHeight;
  } else {
    dimensions.MAX_HEIGHT = dimensions.MAX_DEFAULT_HEIGHT;
  }
};

/**
 * Returns the height of the asset selector tabs (if no tabs it returns zero)
 * @return {number} returns zero
 */
Photocrop.prototype.getTabSelectorHeight = function() {
  var $tabControl = $('.js-asset-selector .js-asset-selector-tabs');
  return $tabControl.length == 0 ? 0 : $tabControl.outerHeight(true);
};

/**
 * Process the image dimensions and initialize the cropper
 *
 * @param {!Object} imageDimensions
 */
Photocrop.prototype.onImageLoad = function(url, imageDimensions) {
  this.imageData = {
    width: imageDimensions.width,
    height: imageDimensions.height,
  };
  $(document).trigger('photocrop.init');

  // sets the dimensions of the cropper container to match the image
  this.setCropperContainer();
  this.$container.css('visibility', 'inherit');
  this.$container.show();
  // add image to cropper
  this.cropperObject.cropper('replace', url);
  // trigger realignment in the dialog
  $(window).trigger('resize');
};

/**
 * Loads a hidden image to the dom and gets necessary image info
 * before intializing the rest of the cropper
 *
 * @param {string} url
 */
Photocrop.prototype.initImageCropping = function(url) {
  var self = this;
  this.$container.css('visibility', 'hidden');
  this.hasInteraction = false;
  image.getImageDimensions(
    url,
    function(imageDimensions) {
      self.onImageLoad(url, imageDimensions);
    },
  );
};

/**
 * Add a listener when the cropper is interacted with
 */
Photocrop.prototype.initCropListener = function() {
  if (!(this.options.constraints && this.options.constraints.cropOnlyOnInteraction)) {
    return;
  }

  var self = this;
  this.$imgContainer
    .one('cropstart.cropper', function(e) {
      self.onCropStart();
    });
};

/**
 * Settings the aspect ratio of the image has constraints
 */
Photocrop.prototype.initAspectRatio = function() {
  if (this.options.constraints && this.options.constraints.aspectRatio) {
    this.cropperObject.cropper('setAspectRatio', this.options.constraints.aspectRatio);
    // set the buttons to the default aspect ratio
    this.setDefaultAspectRatio();
  }
};

/**
 * Sets the view mode of the cropper. A value of 0 allows the cropper to crop
 * outside of the image.
 *
 * @param {int} viewMode View mode id: {0, 1, 2, 3}, or omit to use default view
 */
Photocrop.prototype.setViewMode = function(viewMode) {
  this.options['viewMode'] = viewMode == null ? DEFAULT_VIEW_MODE : viewMode;
  this.initCropper();
};

/**
 * Sets the fillColor of the cropper.
 *
 * @param {string} fillColor
 */
Photocrop.prototype.setFillColor = function(fillColor) {
  this.options['fillColor'] = fillColor;
  this.initCropper();
};

/**
 * Setting the listeners to respect the set Cropbox Dimensions if given
 */
Photocrop.prototype.initCropboxDimensions = function() {
  if (!this.options.constraints) {
    return;
  }

  var self = this;

  // warning bind.(this) is not supported in IE8 and intentionally not used
  this.$imgContainer
    .on('cropmove.cropper', function(e) {
      self.onCropMove(e);
    })
    .on('zoom.cropper', function(e) {
      self.onCropZoom(e);
    });

  var cropboxData = {
    width: this.options.constraints.width,
    height: this.options.constraints.height,
  };

  this.$imgContainer.cropper('setCropBoxData', cropboxData);
};

/**
 * The event handler for when the user drags the cropper
 * @param  {Event} e Event object
 */
Photocrop.prototype.onCropMove = function(e) {
  this.setCropperBox($(e.target));
};

/**
 * initialized the cropperbox on build
 */
Photocrop.prototype.initCropperBox = function() {
  var minWidth; var minHeight = null;
  if (this.options.constraints.aspectRatio == 1) {
    var imageData = this.$imgContainer.cropper('getImageData');
    var maxSide = imageData.width > imageData.height ? imageData.width : imageData.height;
    // default cropper to be largest square width of image
    minWidth = maxSide;
    minHeight = maxSide;
  }

  this.setCropperBox(this.$imgContainer, minWidth, minHeight);
};


/**
 * Sets the cropBox based on image scale
 * @param {!jQuery} $cropper The pointer to the cropper plugin container
 * @param {number|null} minWidth the minimum width of the container or null to default to the constraints
 * @param {number|null} minHeight the minimum height of the container or null to default to constraints
 */
Photocrop.prototype.setCropperBox = function($cropper, minWidth, minHeight) {
  if (!minWidth) {
    minWidth = this.options.constraints.width;
  }

  if (!minHeight) {
    minHeight = this.options.constraints.height;
  }

  var cropboxData = $cropper.cropper('getCropBoxData');
  var imageData = $cropper.cropper('getImageData');
  var scale = imageData.naturalWidth / imageData.width;

  // set the cropper to the minHeight/scale and minWidth/scale and set the mode to only allow drag
  if (cropboxData.width * scale < minWidth || cropboxData.height * scale < minHeight ) {
    cropboxData.width = minWidth/scale + 1;
    cropboxData.height = minHeight/scale + 1;
    $cropper.cropper('setCropBoxData', cropboxData);
    return false; // stop the drag operation
  }
};

/**
 * The event handler for when the user zooms in
 * @param  {Event} e Event object
 */
Photocrop.prototype.onCropZoom = function(e) {
  var $cropper = $(e.target);
  var maxRatio = this.getMaxZoomRatio($cropper);

  if (e.ratio > maxRatio) {
    // we can't zoom below the maxRatio
    $cropper.cropper('zoomTo', maxRatio);
    // prevent the user from zooming in
    return false;
  }
};

Photocrop.prototype.onCropStart = function() {
  this.hasInteraction = true;
};

/**
 * gets the max level the user can zoom in at
 * @param  {!jQuery} $cropper selector for cropper container
 * @return {number} the max level the user can zoom cropper image in
 */
Photocrop.prototype.getMaxZoomRatio = function($cropper) {
  var maxRatioWidth = null;
  var maxRatioHeight = null;
  var minWidth = this.options.constraints.width;
  var minHeight = this.options.constraints.height;
  var cropboxData = $cropper.cropper('getCropBoxData');

  if (!minWidth && !minHeight) {
    return null;
  }

  if (minWidth || minHeight) {
    if (minWidth) {
      maxRatioWidth = parseFloat(cropboxData.width / minWidth);
    }

    if (minHeight) {
      maxRatioHeight = parseFloat(cropboxData.height / minHeight);
    }

    // if we have different zoom limits based on both height and width, set to lowest
    if (maxRatioWidth && maxRatioHeight) {
      return maxRatioWidth < maxRatioHeight ? maxRatioWidth : maxRatioHeight;
    } else if (maxRatioWidth) {
      return maxRatioWidth;
    } else {
      return maxRatioHeight;
    }
  }
};

/**
 * Sets the constraints of the cropper container to
 * respect the image aspect ratio
 * @param {Event} e Event Object
 */
Photocrop.prototype.setCropperContainer = function() {
  var imageData = this.imageData;
  var imageWidth = imageData.width;
  var imageHeight = imageData.height;
  var imageAR = parseFloat(imageWidth/imageHeight);
  var dimensions = this.options.container.dimensions;

  var containerWidth = imageWidth;
  var containerHeight = imageHeight;
  if (this.options.viewMode == 0 && this.options.constraints && this.options.constraints.aspectRatio == 1) {
    // Special Case for BusinessLogo
    // where the viewmode is different and we always respect square
    // aspect ratio, no matter the image
    containerWidth = 300;
    containerHeight = 300;
  } else if (imageAR == 1) { // square image
    if (imageWidth > dimensions.MAX_SQUARE) {
      containerWidth = dimensions.MAX_SQUARE;
      containerHeight = dimensions.MAX_SQUARE;
    }
  } else if (this.options.constraints && this.options.constraints.aspectRatio) {
    if (imageAR > this.options.constraints.aspectRatio) { // More wide
      containerHeight = Math.min(imageHeight, dimensions.MAX_HEIGHT);
      containerWidth = parseFloat(this.options.constraints.aspectRatio * containerHeight);
    } else { // More tall
      containerWidth = Math.min(imageWidth, dimensions.MAX_WIDTH);
      containerHeight = parseFloat(containerWidth / this.options.constraints.aspectRatio);
    }
  } else {
    if (containerWidth >= dimensions.MAX_WIDTH) {
      containerWidth = dimensions.MAX_WIDTH;
      containerHeight = parseFloat(containerWidth/imageAR);
    }

    if (containerHeight >= dimensions.MAX_HEIGHT) {
      containerHeight = dimensions.MAX_HEIGHT;
      containerWidth = containerHeight * imageAR;
    }
  }

  // set the dimensions of the container
  this.$cropArea.css('width', containerWidth).css('height', containerHeight);

  this.$container.show().css('visibility', 'inherit');
};

Photocrop.prototype.setDefaultAspectRatio = function() {
  this.options.$buttons.find('.js-crop-ratios')
    .attr('disabled', true)
    .val(this.options.constraints.aspectRatio)
    .trigger('change');
};

Photocrop.prototype.reset = function() {
  events.resetTitle();
  this.$imgContainer.off('cropmove.cropper');
  this.$imgContainer.off('built.cropper');
  this.$imgContainer.off('zoom.cropper');
  this.$container.hide();
  this.resetAspectRatios();
  this.removeCrop();
  this.options.fillColor = Photocrop.DEFAULTS['fillColor'];
};

Photocrop.prototype.removeCrop = function() {
  this.$imgContainer.attr('src', '').hide();
  if (this.$buttons) {
    this.$buttons.hide();
  }

  // destroy the cropper plugin
  this.$imgContainer.cropper('destroy');
  if (this.$cropArea) {
    this.$cropArea.removeAttr('style');
  }
  this.unbindActions();
  // trigger realignment in the dialog
  $(window).trigger('resize');
};

/**
 * Deselects all aspect ratios and resets the state
 */
Photocrop.prototype.resetAspectRatios = function() {
  var $aspectRatiosDropdown = this.options.$buttons.find('.js-crop-ratios');
  $aspectRatiosDropdown.find('option').removeAttr('selected');
  $aspectRatiosDropdown.removeAttr('disabled').trigger('change');
};

Photocrop.prototype.clearBinds = function() {
  $(document).unbind('photocrop.cropped');
  $(document).unbind('photocrop.failed');
  $(document).unbind('photocrop.discarded');
  $(document).unbind('photocrop.init');
};

Photocrop.prototype.getExternalUrl = function() {
  return routes.Photos.fetch({imageUrl: this.getUrl()});
};


Photocrop.prototype.getUrl = function() {
  var url = this.options.asset.photoUrl;

  if (!url) {
    url = this.options.asset.url;
  }

  return url;
};

/**
 * bind click behavior for modal
 */
Photocrop.prototype.bindActions = function() {
  var self = this;

  this.$buttons.find('.js-crop-upload').on('click', function() {
    // only crop images if they've been interacted with and/or if the
    // original image is within any image constraints
    if (self.canContinueWithoutCrop()) {
      self.continueWithoutCrop();
    } else {
      if (browser.hasCanvasSupport()) {
        self.cropFromCanvas();
      } else {
        self.cropFromServer();
      }
    }
  });

  this.$buttons.find('.js-crop-discard').on('click', function() {
    self.reset();
    $(document).trigger('photocrop.discarded');
    self.clearBinds();
  });

  this.$buttons.find('.js-crop-ratios').on('change', function() {
    self.$imgContainer.cropper('setAspectRatio', $(this).val());
  });
};

/**
 * We can crop directly from the file or url if the cropper hasn't been interacted with
 * and if the cropOnlyOnInteraction constraint is set
 * and if the image aspect ratio respects the required aspect ratio
 * @return {boolean} verifies whether you can crop directly from a file
 */
Photocrop.prototype.canContinueWithoutCrop = function() {
  if (this.options
      && this.options.constraints) {
    if (this.options.constraints.aspectRatio) {
      if (!this.hasInteraction) {
        // make sure the original aspect ratioimage respects the aspect ratio
        var imageAspect = (this.imageData.width / this.imageData.height).toFixed(5);
        var aspectRatio = parseFloat(this.options.constraints.aspectRatio);
        if (this.imageData && !isNaN(aspectRatio)) {
          return imageAspect == aspectRatio.toFixed(5);
        }
      } else {
        return false;
      }
    } else if (this.options.constraints.cropOnlyOnInteraction === true) {
      return !this.hasInteraction;
    } else if (this.options.constraints.cropOnlyOnInteraction === false) {
      return false;
    }
  }
  return true;
};

/**
 * unbind all click behavior for modal
 */
Photocrop.prototype.unbindActions = function() {
  if (this.$buttons) {
    this.$buttons.find('.js-crop-upload').unbind('click');
    this.$buttons.find('.js-crop-discard').unbind('click');
  }
};

/**
 * For instances where the user doesn't interact with the cropped element
 * just use the regular uploaded image
 */
Photocrop.prototype.continueWithoutCrop = function() {
  $(document).trigger('photocrop.cropped', [this.asset, this.options.asset.sourceUrl]);
  this.clearBinds();
};

/**
 * runs file upload to get the cropped imageFile
 * for browsers that don't support canvas, upload to the server and
 * get the base64 version of the file
 */
Photocrop.prototype.cropFromServer = function() {
  var $form = fileupload.buildFileForm();
  var cropData = this.$imgContainer.cropper('getData');
  var self = this;

  var onSuccess = function(data) {
    var imageFile = 'data:image/' + data.fileType + ';base64,' + data.croppedData;
    $(document).trigger('photocrop.cropped', [imageFile]);
    self.clearBinds();
  };

  var onFail = function(data) {
    self.reset();
    $(document).trigger('photocrop.failed', [data]);
    self.clearBinds();
  };

  var onFileUploadDone = function(e, data) {
    onSuccess(data.result);
  };

  var onFileUploadFail = function(e, data) {
    onFail(data.result);
  };
  if (this.options.asset.file) {
    $form.fileupload({
      dropZone: null,
      url: routes.Photos.crop({
        photoUrl: '',
        width: cropData.width,
        height: cropData.height,
        x: cropData.x,
        y: cropData.y}),
      dataType: 'iframejson',
      converters: yext.fileuploadIframeConverters,
      done: onFileUploadDone,
      fail: onFileUploadFail,
    });

    $form.fileupload('send', {
      formData: cropData,
      files: [this.options.asset.file],
      paramName: 'file',
      fileInput: [this.options.asset.fileInput],
      form: $form,
    });
  } else {
    $.ajax({
      type: 'POST',
      url: routes.Photos.crop({
        photoUrl: this.getUrl(),
        width: cropData.width,
        height: cropData.height,
        x: cropData.x,
        y: cropData.y}),
      success: onSuccess,
      fail: onFail,
    });
  }
};

/**
 * Get the cropped image from the cropper plugin canvas
 */
Photocrop.prototype.cropFromCanvas = function() {
  var imageFile = null;
  var croppedCanvas = this.$imgContainer.cropper('getCroppedCanvas', {
    fillColor: this.options['fillColor'],
  });
  var mimeType = 'image/jpeg'; // default to jpeg if we don't get the image's filetype

  if (croppedCanvas) {
    var asset = this.options.asset;

    // make sure the encoded imageType matches the mimeType if possible
    if (asset && asset.file) {
      mimeType = asset.file.type;
    } else if (asset.photoUrl && asset.sourceUrl) {
      var sourceUrlSplit = asset.sourceUrl.split('.');

      if (sourceUrlSplit.length > 0) {
        var fileName = sourceUrlSplit[sourceUrlSplit.length - 1];
        if (fileName != 'jpg') {
          mimeType = 'image/' + fileName;
        }
      }
    }

    try {
      imageFile = croppedCanvas.toDataURL(mimeType);
      $(document).trigger('photocrop.cropped', [imageFile, asset.sourceUrl]);
    } catch (e) {
      $(document).trigger('photocrop.failed');
      throw e;
    }
  } else {
    $(document).trigger('photocrop.failed');
    throw new Error('Invalid CroppedCanvas at:' + window.location.href + ' : ' + croppedCanvas);
  }
  this.clearBinds();
};

exports = Photocrop;
